<template>
    <div class="My_popup">
        <div class="My_popup_wrap">
          <span class="My_popup_close"><a href="#" @click.prevent="closeClickHandler">닫기</a></span>
          <div class="My-popup-title">
              <span class="color-red">{{ safetyDetailInfo.safetyCategory }}</span>({{ safetyDetailInfo.safetyType }}) {{ curState }}
          </div>
          <div class="calamity-map">
              <DrawRegionNaverMap />
          </div>
          <div class="My-popup-content">
              <div class="calamity-pop">
                  <div class="calamity-list">
                      <ul>
                          <li>
                              <span>발생일시</span>
                              <span class="color-red">
                                  {{ (safetyDetailInfo.registerDay + safetyDetailInfo.registerHms) | formatDate('yyyy-MM-dd HH:mm') }}
                              </span>
                          </li>
                          <li>
                              <span>발생위치</span>
                              <span>{{ safetyDetailInfo.shortAddress }}</span>
                          </li>
                          <li>
                              <span>처리기관</span>
                              <span>{{ safetyDetailInfo.controlStation }}</span>
                          </li>
                      </ul>
                  </div>
                  
                  <SafetyInfoHistoryChart :safety-detail-info="safetyDetailInfo"  />
                  
                  <div class="pop_title">유관시설목록</div>
                  <SafetyInfoReleatedOrgList />
              </div>
          </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { $WC } from '@/conf/common.const.js';
import naverMapUtil from "@/lib/grip.naver.map.util.js";
import realtimeApi from "@/api/realtime.api.js";
import NaverMapMixin from "@/store/naver.map.local.mixin.js"
import DrawRegionNaverMap from "@/components/DrawRegionNaverMap.vue";
import SafetyInfoHistoryChart from "@/views/realtime/SafetyInfoHistoryChart.vue";
import SafetyInfoReleatedOrgList from "@/views/realtime/SafetyInfoReleatedOrgList.vue";

export default {
    name: 'SafetyInfoMapWin',
    data() {
        return {
            safetyDetailInfo: {},
            safetyMarkerKey: 'safetyMarker',
        };
    },
    props: {
        registerNo: {
            type: String,
            required: true
        }
    },
    computed: {
        curState: function() {
            let historyList = this.safetyDetailInfo.safetyHistoryList;
            let historyMap = {};
            let lastHistory = {};
            
            if(typeof historyList !== 'undefined') {
                for(let i = 0; i < historyList.length; i++) {
                    let historyStatuCd = historyList[i]['processStateCd'];
                    historyMap['S_' + historyStatuCd] = historyList[i];
                    
                    if(i == (historyList.length - 1)) {
                        lastHistory = historyList[i];
                    }
                }
            }
            
            return '' || lastHistory['processState'];;
        },
    },
    created() {
        // 재난 안전 상세
        this.$eventBus.$once('NaverMap::map-loaded', map => {
            this.naverMaps = map;
        });
        
        this.$eventBus.$once("DrawRegionNaverMap::completed-draw-region", geoJsonDrawing => {
            this.geoJsonDrawing = geoJsonDrawing;
            
            realtimeApi.fetchSafety(this.registerNo)
                .then(res => {
                    this.safetyDetailInfo = res.data.data;
                    this.placeMarker();
                });
        });
        
    },
    methods: {
        closeClickHandler() {
            this.$emit("close-safety-info-map-win");
        },
        placeMarker() {
            let safety = this.safetyDetailInfo;
            if(safety.wtmX && safety.wtmY) {
                let latlng = naverMapUtil.convertWgs84Coords(safety.wtmY, safety.wtmX);
                safety.lttdVal = latlng[0];
                safety.lgtdVal = latlng[1];
                let position = new naver.maps.LatLng(safety.lttdVal, safety.lgtdVal);
                this.naverMaps.setCenter(position);
                let markerImgName = 'marker_activeSafety_' + safety.safetyCategoryCd + '.png';
                let marker = this.makeMarker(this.safetyMarkerKey, safety, () => {}, markerImgName, 'images/marker/', 28, 35);
                this.showMarkers(this.safetyMarkerKey, true);
            }
        },
    },
    mixins: [NaverMapMixin],
    components: {
        DrawRegionNaverMap,
        SafetyInfoHistoryChart,
        SafetyInfoReleatedOrgList
    },
}
</script>